import { Directive, EventEmitter, HostListener, Output } from '@angular/core';

@Directive({
  selector: '[nodaStopPropagation]',
  exportAs: 'nodaStopPropagation',
  standalone: true,
})
export class StopPropagationDirective {
  @Output()
  public eventStopped: EventEmitter<Event> = new EventEmitter<Event>();

  @HostListener('click', ['$event'])
  public onClick(event: Event): void {
    event.stopPropagation();
    this.eventStopped.emit(event);
  }
}
